import { crudPage } from '../../components/crud-page.js';
import { Locations } from '../../api/resources.js';

const TYPES = [
  { value: 'almacen',      label: 'Almacen' },
  { value: 'estudio',      label: 'Estudio' },
  { value: 'oficina',      label: 'Oficina' },
  { value: 'vehiculo',     label: 'Vehiculo' },
  { value: 'evento',       label: 'Evento' },
  { value: 'cliente',      label: 'Cliente' },
  { value: 'mantenimiento',label: 'Mantenimiento' },
  { value: 'sucursal',     label: 'Sucursal' },
  { value: 'otro',         label: 'Otro' },
];

export default async function LocationsPage(outlet) {
  await crudPage(outlet, {
    title: 'Ubicaciones',
    api: Locations,
    columns: [
      { key: 'name',    label: 'Nombre' },
      { key: 'type',    label: 'Tipo' },
      { key: 'address', label: 'Direccion', render: (r) => r.address || '—' },
    ],
    formFields: (item) => [
      { name: 'name', label: 'Nombre', value: item.name, required: true },
      { name: 'type', label: 'Tipo', type: 'select', options: TYPES, value: item.type },
      { name: 'address', label: 'Direccion', value: item.address, full: true },
      { name: 'description', label: 'Descripcion', value: item.description, type: 'textarea', full: true },
    ],
  });
}
